module.exports = require('./lib/index').default;


//////////////////
// WEBPACK FOOTER
// ./~/axios-retry/index.js
// module id = 223
// module chunks = 61